import { render } from "./LandingCarousel.vue?vue&type=template&id=98c4e820&scoped=true"
import script from "./LandingCarousel.vue?vue&type=script&lang=js"
export * from "./LandingCarousel.vue?vue&type=script&lang=js"

import "./LandingCarousel.vue?vue&type=style&index=0&id=98c4e820&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c4e820"]])

export default __exports__